<template>
  <div style="width: 100%;display: flex;justify-content: space-between">
    <span>{{ title }}</span>
    <div style="display: flex;align-items: center">
      <span
        style="text-align: right;margin-right: 10px;color: #0A5BA8;line-height:3px"
      >
        {{
          index == activeKey.find(item => index == item)
            ? "点击闭合"
            : "点击展开"
        }}
      </span>
      <component
        :is="
          index == activeKey.find(item => index == item)
            ? 'svg-reduce-one'
            : 'svg-add-one'
        "
        theme="outline"
        size="22"
        fill="#0A5BA8"
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  name: "renderCollapseHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    index: {
      //弹框名称
      type: Number | String,
      default: 0
    },
    activeKey: {
      type: Array,
      default: []
    }
  },
  mounted() {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/renderCollapseHeader.vue